import { Component, OnInit } from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import { Router } from "@angular/router";
import { MatDialog } from "@angular/material/dialog";
import { BaseForm } from "../../../../../shared/product/baseForm";
import { Balances } from "../../../seller";
import { Validators } from "../../../../../shared/validators";
import { CustomValidators } from "../../../../../shared/custom-validators";
import { PostProductStepService } from "../../services/post-product-step.service";
import { FormValidatorService } from "../../../../../shared/services/form-validator.service";
import { ProductTypes } from "../../../../../shared/product/productTypes";
import { EdittedSuccessfullyComponent } from "../../../../../shared/components/editted-successfully/editted-successfully.component";
import { QuickCashSuccessComponent } from "../../../../../shared/components/quick-cash-success/quick-cash-success.component";
import { TranslateService } from "@ngx-translate/core";
import { LanguageService } from "../../../../../shared/services/language.service";

@Component({
  selector: 'app-quick-cash',
  templateUrl: './quick-cash.component.html',
  styleUrls: ['./quick-cash.component.scss']
})
export class QuickCashComponent extends BaseForm implements OnInit {
  formValidator;
  stepForm!: FormGroup;
  isSubmitting: boolean = false;
  isCashTypeReceived: boolean = true;
  sellerPaymentOptions: any[] = [];
  sellerBalances!: Balances;
  productTypeId: any;
  isUpdate: any;
  controllers = {
    Title: {
      fieldName: "Title",
      fieldNameAr: "العنوان",
      fieldType: "product_image",
      isStaticUI: true,
      defaultValue: "",
      validators: [
        {
          validatorFn: Validators.required,
          message: `${this.validationMsg.required}`,
          messageAr: `${this.validationMsgAr.required}`
        },
        {
          validatorFn: CustomValidators.notInPattern(/^[0-9]*$/),
          message: `${this.validationMsg.notInPattern}`,
          messageAr: `${this.validationMsgAr.notInPattern}`
        },
        {
          validatorFn: Validators.minLength(2),
          message: `${this.validationMsg.minLength}2 characters`,
          messageAr: `${this.validationMsgAr.minLength}حرفان`
        },
      ],
    },
    Amount: {
      fieldName: "Amount",
      fieldNameAr: "المبلغ",
      fieldType: "product_image",
      isStaticUI: true,
      defaultValue: "",
      validators: [
        {
          validatorFn: Validators.required,
          message: `${this.validationMsg.required}`,
          messageAr: `${this.validationMsgAr.required}`
        },
        {
          validatorFn: Validators.min(1),
          message: `${this.validationMsg.min}1`,
          messageAr: `${this.validationMsgAr.min}الـ1`
        },
        {
          validatorFn: CustomValidators.requiredNumber,
          message: `${this.validationMsg.requiredNumber}`,
          messageAr: `${this.validationMsgAr.requiredNumber}`
        },
      ],
    },
    "Cash Expiry Duration": {
      fieldName: "Cash Expiry Duration",
      fieldNameAr: "مدة انتهاء صلاحية النقد",
      fieldType: "no-label-select-list",
      fieldValues: [
        { name: "3" },
        { name: "6" },
        { name: "12" },
        { name: "24" },
        { name: "48" },
      ],
      defaultValue: "3",
      validators: [
        {
          validatorFn: Validators.required,
          message: `${this.validationMsg.required}`,
          messageAr: `${this.validationMsgAr.required}`
        },
      ],
    },
    "Cash Type": {
      fieldName: "Cash Type",
      fieldNameAr: "نوع النقد",
      fieldType: "no-label-select-list",
      fieldValues: [{ name: "Receive" }], // note the two cash types (Send or Received) is setting depend on seller payment options in below of code
      defaultValue: "Receive",
      validators: [
        {
          validatorFn: Validators.required,
          message: `${this.validationMsg.required}`,
          messageAr: `${this.validationMsgAr.required}`
        },
      ],
    },
    Name: {
      fieldName: "Name",
      fieldNameAr: "الإسم",
      fieldType: "product_image",
      isStaticUI: true,
      defaultValue: "",
      validators: [
        {
          validatorFn: Validators.required,
          message: `${this.validationMsg.required}`,
          messageAr: `${this.validationMsgAr.required}`
        },
      ],
    },
    "Payer Email": {
      fieldName: "Payer Email",
      fieldNameAr: "البريد الأليكترونى للدافع",
      fieldType: "product_image",
      isStaticUI: true,
      defaultValue: "",
      validators: [
        {
          validatorFn: Validators.email,
          message: `${this.validationMsg.invalidEmail}`,
          messageAr: `${this.validationMsgAr.invalidEmail}`
        },
      ],
    },
    "Payer Mobile Number": {
      fieldName: "Payer Mobile Number",
      fieldNameAr: "رقم الهاتف للدافع",
      fieldType: "product_image",
      isStaticUI: true,
      defaultValue: "",
      validators: [
        {
          validatorFn: Validators.required,
          message: `${this.validationMsg.required}`,
          messageAr: `${this.validationMsgAr.required}`
        },
        {
          validatorFn: CustomValidators.requiredNumber,
          message: `${this.validationMsg.requiredNumber}`,
          messageAr: `${this.validationMsgAr.requiredNumber}`
        },
        {
          validatorFn: Validators.minLength(11),
          message: `${this.validationMsg.min}11`,
          messageAr: `${this.validationMsgAr.min}الـ11`
        },
        {
          validatorFn: Validators.maxLength(11),
          message: `${this.validationMsg.max}11`,
          messageAr: `${this.validationMsgAr.max}الـ11`
        },
      ],
    },
    Description: {
      fieldName: "Description",
      fieldNameAr: "الوصف",
      fieldType: "product_price",
      isStaticUI: true,
      defaultValue: "",
      validators: [],
    },
  };

  constructor(
    private postStep: PostProductStepService,
    private router: Router,
    private dialog: MatDialog,
    public translate: TranslateService,
    private languageService: LanguageService
  ) {
    super();
    this.formValidator = new FormValidatorService();
  }

  async ngOnInit() {
    if (localStorage.getItem("language")) {
      this.translate.use(localStorage.getItem("language"));
    } else {
      this.translate.use('en');
    }
    this.languageService.languageUpdated.subscribe((lang: string) => {
      this.translate.use(lang);
    });
    this.stepForm = this.formValidator.createForm(
      Object.values(this.controllers)
    );

    this.fromControllers = this.stepForm;
    this.stepForm.markAsUntouched();
  }

  async submit() {
    try {
      this.isSubmitting = true;
      let productValues = {
        Amount: this.stepForm.value.Amount,
        Description: this.stepForm.value.Description,
        phone: this.stepForm.value["Payer Mobile Number"],
        name: this.stepForm.value["Name"],
        email: this.stepForm.value["Payer Email"],
        expiryDuration:
          this.stepForm.value["Cash Type"] == "Receive"
            ? this.stepForm.value["Cash Expiry Duration"]
            : 0,
        Title: this.stepForm.value["Title"],
        type: ProductTypes.quickCash,
        "Cash Type": this.stepForm.value["Cash Type"],
        'Payment options': [{ id: 1, isSelected: true }],
      };
      productValues["Do you want the VAT to be on buyer?"] = !productValues["Do you want the VAT to be on buyer?"];
      this.postStep.setParams(productValues);
      let result = await this.postStep.make();

      const fawryDialRef = this.dialog.open(QuickCashSuccessComponent, {
        data: {
          expiryDate: result.product.voucherExpireData,
          voucher: result.product.voucher,
          provider: result.product.provider,
          isCashTypeReceived: this.isCashTypeReceived,
        },
      });
      this.stepForm.reset();
      this.router.navigate(["/seller/new-products/quick-cash"]);
      this.isSubmitting = false;
    } catch (error) {
      this.isSubmitting = false;
    }
  }

  openCongratulationDialoug(
    url: any,
    productName: any,
    productTypeName: any,
    editMode = false
  ) {
    const dialogRef = this.dialog.open(EdittedSuccessfullyComponent, {
      panelClass: "responsive-dialog",
      data: {
        url: url,
        name: productName,
        type: productTypeName,
      },
    });
  }

  onCashTypeSelect(event: any) {
    this.isCashTypeReceived = event.value == "Receive" ? true : false;
  }

  convertControls(name: string) {
    return this.stepForm.get(name) as FormControl;
  }
}
